export * from "./onboarding-terms-and-conditions-modal.component";
export * from "./onboarding-terms-and-conditions-resellers-modal.component";
